import type { OpBooking } from '@/pages/dashboard/components/RoomOperationBoard';

/**
 * システム導入前から滞在中のBeds24予約かどうかを判定する。
 * operational_status が expected のままでも、arrival_date < 今日 かつ
 * departure_date >= 今日 かつ Beds24由来の場合は「移行時在室予約」として扱う。
 */
export function isImportedInHouseBooking(booking: OpBooking, todayJst: string): boolean {
  return (
    booking.operational_status === 'expected' &&
    booking.booking_status !== 'cancelled' &&
    booking.arrival_date < todayJst &&
    booking.departure_date >= todayJst &&
    booking.booking_origin === 'beds24' &&
    booking.beds24_booking_id != null
  );
}

/**
 * チェックイン操作済みで、まだチェックアウトされていない予約かどうか。
 * 日付に関係なく、実際の操作記録のみで判定する。
 */
export function isCurrentlyInHouse(booking: OpBooking): boolean {
  return (
    booking.operational_status === 'checked_in' &&
    booking.actual_check_out_at === null &&
    booking.booking_status !== 'cancelled'
  );
}